import React from 'react';
import { StyleProps, styles } from './ArticleRichTextLayoutBlock.css';
import { ResponsiveValue, mergeResponsiveValues } from '../../../utils/responsiveValue';
import { useArticleRichTextLayoutBlockProps } from '../../../hooks/useArticleRichTextLayoutBlockProps';
import { spacing } from '@jbhi-fi/lanyard-ui/themes';
import { useResponsiveValue } from '@jbhi-fi/components/src/hooks/useResponsiveValue';

export type ArticleRichTextLayoutBlockProps = {
  paddingTop?: Partial<ResponsiveValue<number>> | number;
  paddingBottom?: Partial<ResponsiveValue<number>> | number;
  paddingLeft?: Partial<ResponsiveValue<number>> | number;
  paddingRight?: Partial<ResponsiveValue<number>> | number;
  backgroundColor?: React.CSSProperties['backgroundColor'];
  children: React.ReactNode;
};

export type ArticleRichTextLayoutBlockStyleProps = Omit<ArticleRichTextLayoutBlockProps, 'children'>;

const defaultStyleProps: ArticleRichTextLayoutBlockStyleProps = {
  paddingTop: { mobile: 4, desktop: 4, desktopLg: 4 },
  paddingBottom: { mobile: 0, desktop: 0, desktopLg: 0 },
  paddingLeft: { mobile: 4, desktop: 8, desktopLg: 8 },
  paddingRight: { mobile: 4, desktop: 8, desktopLg: 8 },
};

const parseStyleProps = (
  componentProps: ArticleRichTextLayoutBlockStyleProps,
  contextProps: ArticleRichTextLayoutBlockStyleProps
): StyleProps => {
  return Object.keys(defaultStyleProps).reduce(
    (acc, key) => ({
      ...acc,
      [key]: mergeResponsiveValues(defaultStyleProps[key], contextProps[key], componentProps[key]),
    }),
    defaultStyleProps
  ) as StyleProps;
};

export const ArticleRichTextLayoutBlock: React.FC<ArticleRichTextLayoutBlockProps> = ({
  children,
  backgroundColor,
  ...componentProps
}) => {
  const { paddingTop, paddingBottom, paddingLeft, paddingRight } = parseStyleProps(
    componentProps,
    useArticleRichTextLayoutBlockProps()
  );
  const {
    paddingTop: paddingTopValue,
    paddingBottom: paddingBottomValue,
    paddingLeft: paddingLeftValue,
    paddingRight: paddingRightValue,
  } = useResponsiveValue<{ paddingTop: number; paddingBottom: number; paddingLeft: number; paddingRight: number }>({
    xs: {
      paddingTop: paddingTop.mobile,
      paddingBottom: paddingBottom.mobile,
      paddingLeft: paddingLeft.mobile,
      paddingRight: paddingRight.mobile,
    },
    md: {
      paddingTop: paddingTop.desktop,
      paddingBottom: paddingBottom.desktop,
      paddingLeft: paddingLeft.desktop,
      paddingRight: paddingRight.desktop,
    },
    lg: {
      paddingTop: paddingTop.desktopLg,
      paddingBottom: paddingBottom.desktopLg,
      paddingLeft: paddingLeft.desktopLg,
      paddingRight: paddingRight.desktopLg,
    },
  });
  return (
    <div
      className={styles.richTextLayoutBlock}
      style={{
        backgroundColor,
        padding: spacing(paddingTopValue, paddingRightValue, paddingBottomValue, paddingLeftValue),
      }}
    >
      {' '}
      {children}{' '}
    </div>
  );
};
